<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button
            variant="primary mr-1"
            @click="importxls()"
            v-if="this.$route.name != 'upload.repaymentbyfilename'"
            ><i class="fa fa-cloud-upload"></i> Import (.xlsx)</b-button
          >
          <b-button
            variant="primary mr-1"
            @click="reprocessbyfilenameconfirm()"
            v-if="this.$route.name == 'upload.repaymentbyfilename'"
            ><i class="fa fa-refresh"></i> Reprocess</b-button
          >
        </div>
      </div>
      <b-row v-if="this.$route.name != 'upload.repaymentbyfilename'">
        <b-col lg="12">
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend
              ><span class="input-group-text"
                >until</span
              ></b-input-group-prepend
            >
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="5" v-if="this.$route.name != 'upload.repaymentbyfilename'">
          <b-input-group>
            <b-input-group-prepend>
              <label>Partner Transaction</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="tblData.partnerTransactionId"
              placeholder=""
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="7" v-if="this.$route.name != 'upload.repaymentbyfilename'">
          <b-input-group>
            <b-input-group-prepend>
              <label>Loan Id</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.loan_id"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="7" v-else>
          <b-input-group>
            <b-input-group-prepend>
              <label>Filename</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.filename"></b-form-input>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
        <template v-slot:cell(index)="data">{{
          (tblData.page - 1) * tblData.limit + (data.index + 1)
        }}</template>
        <template v-slot:cell(Repayment_Date)="data">{{
          data.item.Repayment_Date | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(principalAmount)="data">{{
          data.item.principalAmount | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(interestAmount)="data">{{
          data.item.interestAmount | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(totalRepayment)="data">{{
          data.item.totalRepayment | numFormat("0,0.00")
        }}</template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="showReprocessByFilenameConfirm"
      title="Reprocess ALL Record?"
      :centered="true"
      @ok="reprocessbyfilename"
    >
      <p class="mb-1">All record is about to be processing</p>
      <p class="font-weight-bold m-0 text-danger">
        Warning: You can't undo this action.
      </p>
    </b-modal>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
    <b-modal
      ref="modalprogress"
      v-model="progessupload.show"
      :centered="true"
      hide-footer
    >
      <template #modal-title> PROGRESS {{ progessupload.title }} </template>
      <b-progress
        :value="progessupload.value"
        :max="progessupload.max"
        variant="success"
        striped
        :animated="true"
        show-progress
      ></b-progress>
    </b-modal>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import repayment from "../../apis/repayment";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      showReprocessByFilenameConfirm: false,
      isLoading: false,
      isBusy: false,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: "repaymentupload",
        customQuery: "",
        tgl1: moment().format("YYYY-MM-DD"),
        tgl2: moment().format("YYYY-MM-DD"),
        partnerTransactionId: "",
        loan_id: "",
        filename: "",pjxkey:''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus,
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "Repayment_Date",
          label: "Repayment Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "partnerLoanID",
          label: "partnerLoanID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "principalAmount",
          label: "principalAmount",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "interestAmount",
          label: "interestAmount",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
        {
          key: "totalRepayment",
          label: "totalRepayment",
          thClass: "text-center",
          tdClass: "text-right",
          thStyle: "min-width:100px",
          sortable: true,
        },
      ];
      return fields;
    },
    progessupload() {
      let progessupload = this.$store.state.progessupload;
      if (progessupload && progessupload.refreshdata) {
        this.refresh();
        this.$refs["modalprogress"].hide();
        this.$store.commit("progessupload", {});
      }
      return progessupload;
    },
  },
  created() {
    this.$store.commit("progessupload", {});
    if (this.$route.name == "upload.repaymentbyfilename") {
      this.tblData.filename = this.$route.params.filename;
      this.tblData.pjxkey = this.$route.params.pjxkey;
    }
  },
  methods: {
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isLoading = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `Repayment_Date = between '${this.tblData.tgl1}' and '${this.tblData.tgl2}'`;
        }

        if (this.tblData.partnerTransactionId) {
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `partnerTransactionId=${encodeURIComponent(
            this.tblData.partnerTransactionId
          )}`;
        }

        if (this.tblData.partnerTransactionId) {
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `partnerTransactionId=${encodeURIComponent(
            this.tblData.partnerTransactionId
          )}`;
        }

        if (this.tblData.partnerLoanID) {
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `partnerLoanID=${encodeURIComponent(
            this.tblData.partnerLoanID
          )}`;
        }

        if (this.tblData.filename) {
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `filename=${encodeURIComponent(
            this.tblData.filename
          )}`;
        }

        if(this.tblData.pjxkey){
          this.tblData.customQuery += this.tblData.customQuery ? "&" : "?";
          this.tblData.customQuery = `pjxkey=${encodeURIComponent(
            this.tblData.pjxkey
          )}`;
        }

        const list = await crud.list(this.tblData);
        this.isLoading = false;
        return list;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    reprocessbyfilenameconfirm() {
      this.showReprocessByFilenameConfirm = true;
    },
    async reprocessbyfilename() {
      try {
        this.isLoading = true;
        await repayment.reprocessDataUploadByFilename(this.tblData);
        toastr.success("Reprocess Data Berhasil");
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        await debitur.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async importxls() {
      router.push({ name: "upload.repaymentuploadform" });
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tableKey",
        sortDesc: false,
        tablename: "repaymentupload",
        customQuery: "",
        tgl1: "",
        tgl2: "",
        partnerTransactionId: "",
        loan_id: "",
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    },
  },
};
</script>